module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"info-page\">\n    <h3>Общая информация</h3>\n\n    <div class='add-layer-form'>\n        <div class='add-layer-form-row'>\n            <label>Имя</label>\n\n            <div class='add-layer-form-control'>\n                <control html-name=\"name\" type=\"text\" target=\"item.name\" html-placeholder=\"Введите имя\"></control>\n            </div>\n        </div>\n        <div class='add-layer-form-row'>\n            <label>Описание</label>\n\n            <div class='add-layer-form-control'>\n                <control html-name=\"description\" type=\"text-area\" target=\"item.description\" html-placeholder=\"Введите описание\"></control>\n            </div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}